/* eslint-disable react/prop-types */
import React from "react";
import MediaQuery from "react-responsive";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";
import withErrorGuard from "../../../../../HOC/withErrorGuard";
import showCanonicalLegend from "../../../../../common/helpers/showCanonicalLegend";
import { renderFunctionalAnnotationNotice } from "../TranscriptsTemplate";
import ComponentPanel from "../../../../../components/atoms/ComponentPanel/ComponentPanel";
import EnsemblTranscriptsBoxes from "./EnsemblTranscriptsBoxes";
import EnsemblTranscriptsTable from "./EnsemblTranscriptsTable";
import HelperText from "../../../../../components/atoms/HelperText";

const EnsemblTranscripts = ({
  schema,
  variantResult,
  varsomeHost,
  genomeName,
  isFLT3ITD,
}) => {
  const { ensembl_transcripts: ensemblTranscripts } = variantResult;

  if (schema && variantResult && ensemblTranscripts) {
    const description = schema.properties.ensembl_transcripts;
    const { properties } = description.items.properties.items.items;
    const transcripts = ensemblTranscripts[0].items;
    const genomeSubdomain = genomeName === "hg38" ? "www" : "grch37";
    if (transcripts) {
      if (variantResult.acmg_annotation) {
        const annotationTranscript = variantResult.acmg_annotation.transcript;
        const idx = transcripts.findIndex(
          (x) => x.name === annotationTranscript
        );

        if (idx !== -1) {
          const selectedTranscript = transcripts[idx];
          transcripts.splice(idx, 1);
          transcripts.splice(0, 0, selectedTranscript);
        }
      }
      const tmpl = (
        <div
          className="varsome-inner-container"
          data-testid="ensembl-transcripts"
        >
          <MediaQuery minWidth={768}>
            <EnsemblTranscriptsTable
              variantResult={variantResult}
              transcripts={transcripts}
              varsomeHost={varsomeHost}
              genomeName={genomeName}
              genomeSubdomain={genomeSubdomain}
              properties={properties}
              isFLT3ITD={isFLT3ITD}
            />
            {showCanonicalLegend(transcripts)}
          </MediaQuery>
          <MediaQuery maxWidth={767}>
            <EnsemblTranscriptsBoxes
              variantResult={variantResult}
              transcripts={transcripts}
              varsomeHost={varsomeHost}
              genomeName={genomeName}
              genomeSubdomain={genomeSubdomain}
              properties={properties}
              isFLT3ITD={isFLT3ITD}
            />
          </MediaQuery>
          {renderFunctionalAnnotationNotice()}
        </div>
      );
      return (
        <div className="varsome-result">
          <div className="varsome-container varsome-container__basic">
            <ComponentPanel
              title="Ensembl transcripts"
              url={getVarsoUrl(
                "http://www.ensembl.org/info/genome/genebuild/index.html"
              )}
              helperPopup={
                <HelperText fieldDescriptionKey="Ensembl transcripts" />
              }
              version={ensemblTranscripts[0].version}
              content={tmpl}
            />
          </div>
        </div>
      );
    }
    return null;
  }
  return null;
};
export default withErrorGuard(
  EnsemblTranscripts,
  "EnsemblTranscripts",
  "Ensembl Transcripts"
);
